import { gql } from '@apollo/client';

export interface ReportJobByJobIdNode {
  jobId: string;
  reportId: string;
  startedAt: string;
  targetGroupName: string;
  clientName: string;
  projectName: string;
  workspaceId: number;
  passedQa: boolean;
}

export interface ReportJobByJobIdResponse {
  allReportJobs: {
    nodes: ReportJobByJobIdNode[];
  };
}

export interface ReportJobByJobIdVariables {
  jobId: string;
}

export default gql`
  query ReportJobByJobIdQuery($jobId: UUID!) {
    allReportJobs(condition: { jobId: $jobId }, first: 1) {
      nodes {
        jobId
        reportId
        startedAt
        targetGroupName
        clientName
        projectName
        workspaceId
        passedQa
      }
    }
  }
`;
